// src/utils/patientCode.js
//
// The one rule for showing a patient's ID: the short display code the server
// returns as patientCode (patients.patient_code, e.g. PRV-7K3M9Q), exactly as
// returned — or nothing.
//
// Never build one from the patient's id. Pages used to fall back to
// `PRV-${String(id).padStart(5, '0')}`, which for a UUID is just "PRV-" plus
// the whole UUID — an internal key shown as if it were the patient's code.
// Lab orders booked that way stored it in their own patientCode column, so a
// value that is a system id rather than a display code is dropped as well.

const UUID_RE = /[0-9a-f]{8}-?[0-9a-f]{4}-?[0-9a-f]{4}-?[0-9a-f]{4}-?[0-9a-f]{12}/i;
const BUILT_CODE_RE = /^PRV-\S{9,}$/i;

export const displayPatientCode = (code) => {
  const s = String(code ?? '').trim();
  if (!s || UUID_RE.test(s) || BUILT_CODE_RE.test(s)) return '';
  return s;
};
